import Vue from 'vue';
import Proxy from '@/proxies/SubstoreSubscriptionBeginProxy';
import { PRODUCT_ORDER_SUMMARY, PRODUCT_ORDER_RESERVATION_CONFIRMATION } from '@route-types';

const subscriptionBegin = async (params, originalSubscriptionTemplateId) => {
  params.orderCallId = sessionStorage.getItem('orderCallId');
  sessionStorage.removeItem('orderCallId');

  const response = await new Proxy().create(params);
  // TODO pl: see old substore "var shouldProceed = $scope.applyFeature(..."

  if (response.data.reserved) {
    Vue.router.push({
      name: PRODUCT_ORDER_RESERVATION_CONFIRMATION,
      params: {
        originalSubscriptionTemplateId: originalSubscriptionTemplateId,
        subscriptionTemplateId: params.subscriptionTemplateId,
      },
    });
  } else if (response.data.authenticationURL) {
    window.location.href = response.data.authenticationURL;
  } else {
    // either we don't need to authenticate at a 3rd party site, or we already have done it
    Vue.router.push({
      name: PRODUCT_ORDER_SUMMARY,
      params: {
        originalSubscriptionTemplateId: originalSubscriptionTemplateId,
        subscriptionTemplateId: params.subscriptionTemplateId,
        orderCallId: params.orderCallId,
        fixedLineNumber: params.requestParameter,
      },
    });
  }
};

export default subscriptionBegin;
